function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 8,
  fill: "#CBE6FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.234 16.048c.82.046 1.62.145 2.415.367a7.924 7.924 0 0 1 4.193 2.816 7.837 7.837 0 0 1 0 9.538 7.927 7.927 0 0 1-4.193 2.817c-.796.221-1.595.32-2.415.367-.677.038-1.353.045-2.03.046L21.967 32h-.016c-.919 0-1.82.004-2.724-.047-.82-.047-1.618-.146-2.414-.367a7.927 7.927 0 0 1-4.193-2.817 7.836 7.836 0 0 1 0-9.538 7.924 7.924 0 0 1 4.193-2.816c.796-.222 1.595-.321 2.414-.367a36.737 36.737 0 0 1 2.03-.048h5.253c.92 0 1.822-.004 2.724.048zM29.462 19a5 5 0 1 0 0 10 5 5 0 0 0 0-10z",
  fill: "#2F80ED"
}));

var SvgActivate = function SvgActivate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activate.0985a390.svg";
export { ForwardRef as ReactComponent };